module.exports = {
    version: '11.2.1782'
};
